


















































import { Component, Vue } from 'vue-property-decorator'
import { DxDateBox } from 'devextreme-vue/ui/date-box'
import { DxButton } from 'devextreme-vue/ui/button'
import {
  DxDataGrid,
  DxLoadPanel,
  DxColumn,
  DxScrolling,
  DxPaging,
  DxFilterRow
} from 'devextreme-vue/data-grid'
import FileManagementService from '@/services/file-management-service'
import UserManagerService from '@/services/data/user_manager'
import { Message } from 'element-ui'

interface HistoryItem {
  date_created: string
  created_by_id: string
  subj_path: string
  action: string
  user_name?: string
}

@Component({
  name: 'DocumentHistory',
  components: {
    DxDateBox,
    DxButton,
    DxDataGrid,
    DxLoadPanel,
    DxColumn,
    DxScrolling,
    DxPaging,
    DxFilterRow
  }
})
export default class extends Vue {
  startDate: Date | null = null
  endDate: Date | null = null
  historyData: HistoryItem[] = []
  loading: boolean = false
  usersMap: Map<string, { full_name?: string; login?: string }> = new Map()
  usersLoaded: boolean = false
  gridHeight: number = 0

  get columns() {
    return [
      {
        dataField: 'user_name',
        caption: 'Имя пользователя',
        width: 200,
        allowSorting: true,
        allowFiltering: true,
        calculateCellValue: (rowData: HistoryItem) => {
          return rowData.user_name || 'Загрузка...'
        }
      },
      {
        dataField: 'action',
        caption: 'Действие',
        allowSorting: true,
        allowFiltering: true,
        minWidth: 150
      },
      {
        dataField: 'subj_path',
        caption: 'Путь',
        allowSorting: true,
        allowFiltering: true,
        minWidth: 150
      },
      {
        dataField: 'date_created',
        caption: 'Дата',
        dataType: 'datetime',
        width: 180,
        allowSorting: true,
        allowFiltering: false,
        format: 'dd.MM.yyyy HH:mm:ss'
      }
    ]
  }

  async created() {
    this.startDate = this.getMondayOfCurrentWeek()
    this.endDate = this.getSundayOfCurrentWeek()
    await this.loadUsers()
  }

  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
    })
    window.addEventListener('resize', this.setTableHeight)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }

  setTableHeight() {
    this.$nextTick(() => {
      const container = this.$refs.tableContainer as HTMLElement
      if (container) {
        const containerRect = container.getBoundingClientRect()
        const height = window.innerHeight - containerRect.top - 170
        if (height > 200) {
          this.gridHeight = height
        } else {
          this.gridHeight = 0
        }
      }
    })
  }

  async loadUsers() {
    if (this.usersLoaded) return

    try {
      const response = await UserManagerService.get()
      if (response && response.data) {
        response.data.forEach((user: any) => {
          this.usersMap.set(user.id, {
            full_name: user.full_name,
            login: user.login
          })
        })
        this.usersLoaded = true
      }
    } catch (error) {
      console.error('Ошибка при загрузке списка пользователей:', error)
    }
  }

  getMondayOfCurrentWeek(): Date {
    const today = new Date()
    const day = today.getDay()
    const diff = today.getDate() - day + (day === 0 ? -6 : 1) // Adjust when day is Sunday
    const monday = new Date(today.getFullYear(), today.getMonth(), diff)
    monday.setHours(0, 0, 0, 0)
    return monday
  }

  getSundayOfCurrentWeek(): Date {
    const today = new Date()
    const day = today.getDay()
    const diff = today.getDate() - day + (day === 0 ? -6 : 1)
    const monday = new Date(today.getFullYear(), today.getMonth(), diff)
    const sunday = new Date(monday)
    sunday.setDate(monday.getDate() + 6)
    sunday.setHours(23, 59, 59, 999)
    return sunday
  }

  formatDate(date: Date): string {
    if (!date) return ''
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  getUserName(userId: string): string {
    const user = this.usersMap.get(userId)
    if (user) {
      return user.full_name || user.login || 'Неизвестно'
    }
    return 'Неизвестно'
  }


  async onLoad() {
    if (!this.startDate || !this.endDate) {
      Message.warning('Выберите диапазон дат')
      return
    }

    this.loading = true
    this.historyData = []

    try {
      const fDate = this.formatDate(this.startDate)
      const tDate = this.formatDate(this.endDate)

      const data = await FileManagementService.getFileHistory(fDate, tDate)

      if (!this.usersLoaded) {
        await this.loadUsers()
      }

      const historyWithUsers = data.map((item: HistoryItem) => {
        const userName = this.getUserName(item.created_by_id)
        return {
          ...item,
          user_name: userName
        }
      })

      this.historyData = historyWithUsers
      this.$emit('load', {
        startDate: this.startDate,
        endDate: this.endDate
      })
      this.$nextTick(() => {
        this.setTableHeight()
      })
    } catch (error) {
      console.error('Ошибка при загрузке истории изменений:', error)
      Message.error('Не удалось загрузить историю изменений')
    } finally {
      this.loading = false
    }
  }
}
